<template>
    <div id="anchor-reviews">
        <div v-if="loading">
            <device-average-rating-reviews-skeleton />
        </div>
        <template v-else>
            <div class="bg-gray2 py-2 mb-2">
                <div class="row mx-0">
                    <!--/* Zone Note moyenne */-->
                    <div
                        v-if="reviewsStatsAverage"
                        class="col-12 col-md-6 d-md-flex justify-content-center"
                        :class="hasAverageRatings ? 'border-end border-gray4' : null"
                    >
                        <device-rating-reviews
                            :title="reviewsMessages.ratingTitle"
                            :link-label="reviewsMessages.ratingLinkLabel"
                            :link-url="reviewsMessages.ratingLinkUrl"
                            :average="reviewsStatsAverage"
                            :text="reviewsStatsText"
                            :rating-results-height="1.375"
                        />
                    </div>
                    <template v-if="hasAverageRatings">
                        <div class="col-12 d-md-none">
                            <ob1-separateur class="my-2" />
                        </div>
                        <!--/* Zone Dans le détail */-->
                        <div class="col-12 col-md-6 d-md-flex justify-content-center">
                            <reviews-average-ratings
                                :subtitle="reviewsMessages.averageRatingsSubtitle"
                                :average-ratings="averageRatings"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import DeviceRatingReviews from "./DeviceRatingReviews.vue";
import ReviewsAverageRatings from "./ReviewsAverageRatings.vue";
import DeviceAverageRatingReviewsSkeleton from "./DeviceAverageRatingReviewsSkeleton.vue";

export default {
    name: "DeviceAverageRatingReviews",
    components: {DeviceAverageRatingReviewsSkeleton, ReviewsAverageRatings, DeviceRatingReviews},
    props: {
        averageRatings: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
        reviewsStatsAverage: {
            type: Number,
            required: true
        },
        reviewsStatsText: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        hasAverageRatings() {
            return this.averageRatings.length > 0;
        },
    },
}
</script>
